import { useTranslation } from "../../core/translation.core";
import { ProductStatus } from "../../types/product";

export default function ProductStatusSpanComp({ status }: { status: ProductStatus }) {
  const { t, msg } = useTranslation();

  switch (status) {
    case "active":
      return <span data-label={`status-${status}`}>{t(msg.product.active)}</span>;
    case "draft":
      return <span data-label={`status-${status}`}>{t(msg.product.draft)}</span>;
    case "private":
      return <span data-label={`status-${status}`}>{t(msg.product.private)}</span>;
    case "deleted":
      return <span data-label={`status-${status}`}>{t(msg.product.deleted)}</span>;
    default:
      return null;
  }
}
